export default __webpack_public_path__ + "static/media/react.a900547a.svg";